module.exports = ".default{\r\n\tvisibility: hidden;\r\n\topacity: 0;\r\n\t-webkit-transition: visibility 2s, opacity 2s;\r\n\ttransition: visibility 2s, opacity 2s;\r\n}\r\n.visible{\r\n\tvisibility: visible;\r\n\topacity: 1;\r\n\t-webkit-transition: visibility 0s, opacity 2s;\r\n\ttransition: visibility 0s, opacity 2s;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/banner/banner.component.css
// module id = ./src/app/banner/banner.component.css
// module chunks = main